// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions"; // Import getFunctions
import { getStorage } from "firebase/storage"; // Add this import

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

function normalizeStorageBucket(bucket, projectId) {
  const raw = String(bucket || "").trim();

  if (raw.endsWith(".appspot.com")) {
    return raw.replace(/\.appspot\.com$/i, ".firebasestorage.app");
  }

  if (raw) return raw;
  if (projectId) return `${projectId}.firebasestorage.app`;
  return "";
}

const resolvedStorageBucket = normalizeStorageBucket(
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  process.env.REACT_APP_FIREBASE_PROJECT_ID,
);

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: resolvedStorageBucket,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export const functions = getFunctions(app); // Initialize functions

export const storage = resolvedStorageBucket
  ? getStorage(app, `gs://${resolvedStorageBucket}`)
  : getStorage(app); // Initialize and export storage
